import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

const StyledBlockContainer = styled.div<{ $isFooter: boolean }>`
    ${(p) => (p.$isFooter ? 'margin-top: 4rem;' : null)};
`;


const BlockArea = ({ blocks, isFooter = false }) => {
    const blockContainerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!blockContainerRef?.current) return;
        blockContainerRef.current.innerHTML = '';
        for (let block of blocks) {
            blockContainerRef.current.appendChild(block);
        }
    }, [blockContainerRef, blocks]);

    return (
        <StyledBlockContainer $isFooter={isFooter}>
            {blocks.length > 0 && <div ref={blockContainerRef}></div>}
        </StyledBlockContainer>
    );
};

export default BlockArea;
